import { render } from "./BusinessDashboard.vue?vue&type=template&id=76fa0e91"
import script from "./BusinessDashboard.vue?vue&type=script&lang=js"
export * from "./BusinessDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__